import type { EChartsType } from 'echarts/core';

const getLegendHeightFromView = (chart: EChartsType): number => {
  const chartRecord = chart as unknown as Record<string, unknown>;
  const getModel = chartRecord.getModel;
  if (typeof getModel !== 'function') return 0;

  const model = Reflect.apply(getModel, chart, []) as
    | {
        getComponent?: (name: string, index?: number) => unknown;
      }
    | undefined;

  if (!model || typeof model.getComponent !== 'function') return 0;

  const legendModel = model.getComponent('legend', 0);
  if (!legendModel) return 0;

  const getView = chartRecord.getViewOfComponentModel;
  if (typeof getView !== 'function') return 0;

  const view = Reflect.apply(getView, chart, [legendModel]) as
    | {
        group?: { getBoundingRect?: () => { height: number } };
      }
    | undefined;

  const rect = view?.group?.getBoundingRect?.();

  return rect && rect.height > 0 ? rect.height : 0;
};

export const getEChartsLegendHeight = (chart: EChartsType): number => {
  if (chart.isDisposed?.()) return 0;

  try {
    return getLegendHeightFromView(chart);
  } catch {
    return 0;
  }
};
